import React from 'react';

const UsersSvg = () => {
    return (
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.0026 3.8335C10.8867 3.8335 11.7345 4.18469 12.3596 4.80981C12.9847 5.43493 13.3359 6.28277 13.3359 7.16683C13.3359 8.05088 12.9847 8.89873 12.3596 9.52385C11.7345 10.149 10.8867 10.5002 10.0026 10.5002C9.11855 10.5002 8.2707 10.149 7.64558 9.52385C7.02046 8.89873 6.66927 8.05088 6.66927 7.16683C6.66927 6.28277 7.02046 5.43493 7.64558 4.80981C8.2707 4.18469 9.11855 3.8335 10.0026 3.8335ZM10.0026 12.1668C13.6859 12.1668 16.6693 13.6585 16.6693 15.5002V17.1668H3.33594V15.5002C3.33594 13.6585 6.31927 12.1668 10.0026 12.1668Z"
                fill="#006CDD"
            />
        </svg>
    );
};

export default UsersSvg;
